export default {
  WAITING_LP_APPROVE: {
    label: 'Aguardando aprovação do transportador',
    value: 'WAITING_LP_APPROVE',
  },
  WAITING_PAYMENT_READY: {
    label: 'Aguardando liberação do pagamento',
    value: 'WAITING_PAYMENT_READY',
  },
  READY_FOR_PAYMENT: {
    label: 'Liberado para pagamento',
    value: 'READY_FOR_PAYMENT',
  },
  PAID: {
    label: 'Pagamento realizado',
    value: 'PAID',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-audit/enums/EnumStatus.js